import React from 'react';
import PropTypes from 'prop-types';
import {Navigation} from '@homeaway/react-navigation';
import {Link} from 'gatsby';

export default function ArchiveNavigation({years, slug, pathname}) {
    const links = years
        .sort((a, b) => b - a)
        .map((year) => ({
            label: year,
            href: '',
            node: <Link to={`/${slug}/${year}`}>{year}</Link>,
        }));

    const activeIndex = years.indexOf(
        years.find((year) => pathname.includes(year)),
    );
    return (
        <Navigation
            links={links}
            activeIndex={activeIndex}
            withBorder
            noMobileSelect
        />
    );
}

ArchiveNavigation.propTypes = {
    years: PropTypes.arrayOf(PropTypes.string).isRequired,
    slug: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
};
